<template>
  <TransitionGroup name="list" tag="div" class="notification-container">
    <div v-for="(notification, index) in notificationsStore.notifications" :key="notification.hash" class="notification-widget" :class="['type-' + notification.type, 'shake' + notification.timestamp]">
      <div class="notification-widget__icon">
        <svg v-if="notification.type === NotificationTypes.Error" x="0px" y="0px" viewBox="0 0 512 512"><path d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.507,256,256,256c141.503,0,256-114.507,256-256 C512,114.497,397.493,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.615-216,216-216 c119.393,0,216,96.615,216,216C472,375.393,375.385,472,256,472z"/><path d="M256,128.877c-11.046,0-20,8.954-20,20V277.67c0,11.046,8.954,20,20,20s20-8.954,20-20V148.877 C276,137.831,267.046,128.877,256,128.877z"/><circle cx="256" cy="349.16" r="27"/></svg>
        <svg v-else-if="notification.type === NotificationTypes.Success" x="0" y="0" viewBox="0 0 367.805 367.805" xml:space="preserve"><path style="" d="M183.903,0.001c101.566,0,183.902,82.336,183.902,183.902s-82.336,183.902-183.902,183.902   S0.001,285.469,0.001,183.903l0,0C-0.288,82.625,81.579,0.29,182.856,0.001C183.205,0,183.554,0,183.903,0.001z" fill="#3bb54a" data-original="#3bb54a"></path><polygon style="" points="285.78,133.225 155.168,263.837 82.025,191.217 111.805,161.96 155.168,204.801    256.001,103.968  " fill="#d4e1f4" data-original="#d4e1f4" class=""></polygon></svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" width="512" height="512" x="0" y="0" viewBox="0 0 48 48" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><circle xmlns="http://www.w3.org/2000/svg" cx="24" cy="24" fill="#2196f3" r="18" data-original="#2196f3" class=""></circle><g xmlns="http://www.w3.org/2000/svg" fill="#fff"><circle cx="24" cy="15.5" r="2.5" fill="#ffffff" data-original="#ffffff" class=""></circle><path d="m22 21h4v14h-4z" fill="#ffffff" data-original="#ffffff" class=""></path></g></g></svg>      </div>
      <p class="notification-widget__notification">{{ notification.notification }}</p>
      <div class="notification-widget__close" @click="deleteNotification(index)">
        <svg height="10" viewBox="0 0 413.348 413.348" width="10"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
      </div>
    </div>
  </TransitionGroup>
</template>

<script lang="ts" setup>
import { NotificationTypes } from '@/types';
import { useNotificationsStore } from '@/store/notifications.store';

const notificationsStore = useNotificationsStore();

const deleteNotification = (index:number):void => {
  notificationsStore.deleteNotification(index);
};

</script>

<style lang="scss" scoped>
.notification-container {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 10000;
  padding-right: 10px;
}

.notification-widget {
  white-space: nowrap;
  border-radius: 7px;
  max-width: 90vw;
  padding: 10px 30px 10px 20px;
  margin-top: 10px;
  margin-left: auto;
  display: flex;
  width: fit-content;
  align-items: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  transition: box-shadow 0.3s, transform 0.5s, top 0.5s, height 0.5s, opacity 0.3s;
  will-change: box-shadow, transform, top, height, opacity;

  &:hover {
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);
  }

  &.hidding {
    top: -10%;
  }

  &.shake {
    animation: shake 0.5s;
  }

  &__notification {
    margin-bottom: 0;
    margin-right: 10px;
    pointer-events: none;
    user-select: none;
  }

  &.type-error {
    background-color: #ffe1e2;
    color: #fc5c65;

    svg {
      fill: #fc5c65;
    }
  }

  &.type-success {
    background-color: #deffc4;
    color: #91C483;
  }

  &__close {
    position: absolute;
    right: 20px;
    margin-left: 10px;
    cursor: pointer;
    transition: transform 0.4s, fill 0.3s;
    will-change: transform, fill;

    &:hover {
      transform: scale(1.2);
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    margin-right: 10px;

    svg {
      height: 20px;
      width: auto;
    }
  }
}

@keyframes shake {

  0% {
    transform: translateX(-20px);
  }

  10% {
    transform: translateX(-10px);
  }

  20% {
    transform: translateX(-27px);
  }

  50% {
    transform: translateX(-16px);
  }

  70% {
    transform: translateX(-23px);
  }

  100% {
    transform: translateX(-20px);
  }
}

.list-move,
.list-enter-active,
.list-leave-active {
  transition: all 0.3s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.list-leave-active {
  position: absolute;
}
</style>